/**
 * @typedef {object} HotspotConfig
 * @property {string} key
 * @property {string} cardName
 * @property {string} label
 */

/** @type {HotspotConfig[]} */
export const HOTSPOT_CONFIGS = Object.freeze([
  {
    key: "01_FlüssigbodenAllg",
    cardName: "fluessigbodenAllg",
    label: "Flüssigboden allgemein",
  },
  {
    key: "02_BodenVerarbeiten",
    cardName: "bagger",
    label: "Bodenarten verarbeiten",
  },
  {
    key: "03_Schadstoffbindung",
    cardName: "schadstoffbindung",
    label: "Schadstoffbindung",
  },
  {
    key: "04_Anlagentechnik",
    cardName: "mischer",
    label: "Anlagentechnik und Produktion",
  },
  {
    key: "05_Wärmeleitfähigkeit",
    cardName: "waermeleitfaehigkeit",
    label: "Wärmeleitfähigkeit",
  },
  {
    key: "06_Arbeitsraumverfüllung",
    cardName: "arbeitsraumverfuellung",
    label: "Arbeitsraum- und Hohlraumverfüllung",
  },
  {
    key: "07_Einbau",
    cardName: "einbau",
    label: "Einbau",
  },
  {
    key: "08_Kanalbau",
    cardName: "kanalbau",
    label: "Kanalbau",
  },
  {
    key: "09_Lastenausgleichschicht",
    cardName: "lastenausgleichschicht",
    label: "Lastenausgleichschicht",
  },
  {
    key: "10_Energiemonolith",
    cardName: "energiemonolith",
    label: "Energiemonolith",
  },
  {
    key: "11_Rezeptur",
    cardName: "rezeptur",
    label: "Rezepturentwicklung / Eignungsprüfung",
  },
]);

export function getHotspotNavigation(configs, currentKey) {
  const currentIndex = configs.findIndex((config) => config.key === currentKey);
  if (currentIndex < 0 || configs.length === 0) return null;

  return {
    previous:
      configs[(currentIndex - 1 + configs.length) % configs.length],
    current: configs[currentIndex],
    next: configs[(currentIndex + 1) % configs.length],
  };
}

export function getSiblingHotspotConfig(configs, currentKey, direction) {
  const navigation = getHotspotNavigation(configs, currentKey);
  if (!navigation) return null;
  return direction < 0 ? navigation.previous : navigation.next;
}
